export function SocialConnectionsDetails() {
  return (
    <div className="space-y-8">
      <h2 className="text-2xl font-bold text-gray-900">Social Connection Details</h2>
      
      <div className="bg-white rounded-lg p-8 border border-gray-200">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Connection Type */}
          <div className="space-y-3">
            <label className="block text-lg text-gray-700 font-medium">
              Type of Connection <span className="text-red-500">*</span>
            </label>
            <select
              className="w-full p-4 text-lg rounded-lg bg-gray-50 border border-gray-200"
            >
              <option value="">Select connection type</option>
              <option value="lifelong_friendship">Lifelong Friendship</option>
              <option value="group_formation">Group Formation</option>
              <option value="community_joining">Community Joining</option>
              <option value="mentorship">Mentorship Bond</option>
              <option value="shared_journey">Shared Journey</option>
            </select>
          </div>

          {/* Connection Name/Group */}
          <div className="space-y-3">
            <label className="block text-lg text-gray-700 font-medium">
              Connection Name/Group <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              className="w-full p-4 text-lg rounded-lg bg-gray-50 border border-gray-200"
              placeholder="Enter person, group, or community name"
            />
          </div>

          {/* Start Date */}
          <div className="space-y-3">
            <label className="block text-lg text-gray-700 font-medium">
              Start Date <span className="text-red-500">*</span>
            </label>
            <input
              type="date"
              className="w-full p-4 text-lg rounded-lg bg-gray-50 border border-gray-200"
            />
          </div>

          {/* Location */}
          <div className="space-y-3">
            <label className="block text-lg text-gray-700 font-medium">
              Location <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              className="w-full p-4 text-lg rounded-lg bg-gray-50 border border-gray-200"
              placeholder="City, State/Province, Country"
            />
          </div>

          {/* Connection Context */}
          <div className="space-y-3">
            <label className="block text-lg text-gray-700 font-medium">
              Connection Context
            </label>
            <select
              className="w-full p-4 text-lg rounded-lg bg-gray-50 border border-gray-200"
            >
              <option value="">Select context</option>
              <option value="school">School/Education</option>
              <option value="work">Work/Professional</option>
              <option value="hobby">Hobby/Interest</option>
              <option value="community">Community/Neighborhood</option>
              <option value="online">Online/Digital</option>
              <option value="travel">Travel/Adventure</option>
            </select>
          </div>

          {/* Frequency of Interaction */}
          <div className="space-y-3">
            <label className="block text-lg text-gray-700 font-medium">
              Frequency of Interaction
            </label>
            <select
              className="w-full p-4 text-lg rounded-lg bg-gray-50 border border-gray-200"
            >
              <option value="">Select frequency</option>
              <option value="daily">Daily</option>
              <option value="weekly">Weekly</option>
              <option value="monthly">Monthly</option>
              <option value="quarterly">Quarterly</option>
              <option value="annually">Annually</option>
            </select>
          </div>

          {/* Shared Interests/Activities */}
          <div className="col-span-2 space-y-3">
            <label className="block text-lg text-gray-700 font-medium">
              Shared Interests/Activities
            </label>
            <textarea
              className="w-full h-32 p-4 text-lg rounded-lg bg-gray-50 border border-gray-200"
              placeholder="Describe common interests, activities, or goals"
            />
          </div>

          {/* Impact/Significance */}
          <div className="col-span-2 space-y-3">
            <label className="block text-lg text-gray-700 font-medium">
              Impact/Significance
            </label>
            <textarea
              className="w-full h-32 p-4 text-lg rounded-lg bg-gray-50 border border-gray-200"
              placeholder="Describe the significance of this connection in your life"
            />
          </div>
        </div>
      </div>
    </div>
  )
} 